<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Ghostly Tales of San Diego</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head">T<span class="small">ABLE OF</span> C<span class="small">ONTENTS</span> &amp; M<span class="small">AP</span> K<span class="small">EY</span></p>
<table>
<colgroup>
<col width="70px"/>
<col width="320px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><a href="#/Introduction#Intro">Introduction</a></td></tr>
<tr><td><a href="#/Chapter01#C1">Chapter 1.</a></td><td><a href="#/Chapter01#C1">Casa de Estudillo</a></td></tr>
<tr><td><span href="#/Chapter02#C2" title="Link target outside of Sample">Chapter 2.</span></td><td><span href="#/Chapter02#C2" title="Link target outside of Sample">The Haunted Shops of Old Town</span></td></tr>
<tr><td><span href="#/Chapter03#C3" title="Link target outside of Sample">Chapter 3.</span></td><td><span href="#/Chapter03#C3" title="Link target outside of Sample">Cosmopolitan Hotel</span></td></tr>
<tr><td><span href="#/Chapter04#C4" title="Link target outside of Sample">Chapter 4.</span></td><td><span href="#/Chapter04#C4" title="Link target outside of Sample">El Campo Santo Cemetery</span></td></tr>
<tr><td><span href="#/Chapter05#C5" title="Link target outside of Sample">Chapter 5.</span></td><td><span href="#/Chapter05#C5" title="Link target outside of Sample">Haunted Village Restaurants and The Old Town Saloon</span></td></tr>
<tr><td><span href="#/Chapter06#C6" title="Link target outside of Sample">Chapter 6.</span></td><td><span href="#/Chapter06#C6" title="Link target outside of Sample">Whaley House</span></td></tr>
<tr><td><span href="#/Chapter07#C7" title="Link target outside of Sample">Chapter 7.</span></td><td><span href="#/Chapter07#C7" title="Link target outside of Sample">William Heath Davis House</span></td></tr>
<tr><td><span href="#/Chapter08#C8" title="Link target outside of Sample">Chapter 8.</span></td><td><span href="#/Chapter08#C8" title="Link target outside of Sample">Horton Grand Hotel</span></td></tr>
<tr><td><span href="#/Chapter09#C9" title="Link target outside of Sample">Chapter 9.</span></td><td><span href="#/Chapter09#C9" title="Link target outside of Sample">The <i>Star of India</i></span></td></tr>
<tr><td><span href="#/Chapter10#C10" title="Link target outside of Sample">Chapter 10.</span></td><td><span href="#/Chapter10#C10" title="Link target outside of Sample">Steamship <i>Berkeley</i></span></td></tr>
<tr><td><span href="#/Chapter11#C11" title="Link target outside of Sample">Chapter 11.</span></td><td><span href="#/Chapter11#C11" title="Link target outside of Sample">USS <i>Midway</i></span></td></tr>
<tr><td><span href="#/Chapter12#C12" title="Link target outside of Sample">Chapter 12.</span></td><td><span href="#/Chapter12#C12" title="Link target outside of Sample">Point Loma Lighthouse</span></td></tr>
<tr><td><span href="#/Chapter13#C13" title="Link target outside of Sample">Chapter 13.</span></td><td><span href="#/Chapter13#C13" title="Link target outside of Sample">The Hotel del Coronado</span></td></tr>
<tr><td colspan="2"><span href="#/Conclusion#Con" title="Link target outside of Sample">Conclusion</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?c19397b4